module.exports = __webpack_public_path__ + "static/boredom-7bb7618602e29709020f0a9d836c2229.png";